(function () {
  'use strict';

  function bindGa4CtaTracking(root) {
    if (!root || root.dataset.ga4CtaBound === 'true') return;
    root.dataset.ga4CtaBound = 'true';
    root.addEventListener('click', function (event) {
      var link = event.target.closest('.cust-banner-secondary-card__cta[href]');
      if (!link || !root.contains(link) || !link.getAttribute('data-ga4-creative-slot')) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: 'click_banner',
        event_parameters: {
          creative_slot: link.getAttribute('data-ga4-creative-slot'),
          position: parseInt(link.getAttribute('data-ga4-position') || '1', 10),
          creative_name: link.getAttribute('data-ga4-creative-name') || '',
          button_name: link.getAttribute('data-ga4-button-name') || '',
        },
      });
    });
  }

  function showJojoHomeSlide() {
    var section = document.querySelector('.section-home-slideshow');
    if (!section) return;

    section.scrollIntoView({ behavior: 'smooth', block: 'start' });

    var swiperEl = section.querySelector('.home-slideshow-swiper');
    var swiper = swiperEl && swiperEl.swiper;
    if (!swiper) return;

    var slide = swiperEl.querySelector('.swiper-slide.jojo-coming-home:not(.swiper-slide-duplicate)');
    if (!slide) return;

    var index = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
    if (isNaN(index)) return;

    if (swiper.params && swiper.params.loop && typeof swiper.slideToLoop === 'function') {
      swiper.slideToLoop(index);
    } else if (typeof swiper.slideTo === 'function') {
      swiper.slideTo(index);
    }
  }

  function bindJojoCampaign(root) {
    root.querySelectorAll('.jojo-campaign .cust-banner-secondary-card').forEach(function (card) {
      if (!card.getAttribute('role')) card.setAttribute('role', 'button');
      if (!card.hasAttribute('tabindex')) card.tabIndex = 0;
      if (!card.getAttribute('aria-label')) {
        var heading = card.querySelector('.cust-banner-secondary-card__heading');
        var label = heading ? heading.textContent.trim() : '';
        if (label) card.setAttribute('aria-label', label);
      }
    });

    if (root.dataset.jojoCampaignBound === 'true') return;
    root.dataset.jojoCampaignBound = 'true';

    root.addEventListener('click', function (event) {
      var card = event.target.closest('.jojo-campaign .cust-banner-secondary-card');
      if (!card || !root.contains(card)) return;
      if (event.target.closest('.cust-banner-secondary-card__cta')) return;
      showJojoHomeSlide();
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var card = event.target.closest('.jojo-campaign .cust-banner-secondary-card');
      if (!card || event.target !== card || !root.contains(card)) return;
      event.preventDefault();
      showJojoHomeSlide();
    });
  }

  function initCustBannerSecondary(root) {
    if (!root || root.dataset.custBannerSecondaryReady === 'true') return;
    bindGa4CtaTracking(root);
    bindJojoCampaign(root);

    var slideCount = parseInt(root.getAttribute('data-slide-count') || '0', 10);
    if (slideCount < 2) {
      root.dataset.custBannerSecondaryReady = 'true';
      return;
    }

    if (typeof Swiper === 'undefined') return;

    var sectionId = root.id.replace('cust-banner-secondary-', '');
    var swiperEl = root.querySelector('.cust-banner-secondary__swiper-' + sectionId);
    if (!swiperEl || swiperEl.swiper) {
      root.dataset.custBannerSecondaryReady = 'true';
      return;
    }

    new Swiper(swiperEl, {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 16,
      speed: 500,
      watchOverflow: true,
      breakpoints: {
        769: {
          slidesPerView: 2,
          slidesPerGroup: 1,
          spaceBetween: 24
        }
      },
      pagination: {
        el: root.querySelector('.cust-banner-secondary__pagination-' + sectionId),
        clickable: true,
      },
      navigation: {
        prevEl: root.querySelector('.cust-banner-secondary__prev-' + sectionId),
        nextEl: root.querySelector('.cust-banner-secondary__next-' + sectionId),
      },
    });

    root.dataset.custBannerSecondaryReady = 'true';
  }

  function boot(scope) {
    var container = scope || document;
    container.querySelectorAll('[data-cust-banner-secondary]').forEach(initCustBannerSecondary);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) boot(event.target);
  });
})();
